// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"524":"92dac35f","580":"fb65e8d4"}[chunkId] + ".chunk.css";
};